import React, { useEffect, useRef } from "react";
// AuthStack
import Login from "./screens/authStack/Login";
import Register from "./screens/authStack/Register";

// AppStack
import Dashboard from "./screens/appStack/Dashboard";
import Sightings from "./screens/appStack/Sightings";
import AdminSettings from "./screens/appStack/AdminSettings";
import PrivacyPolicy from "./screens/appStack/PrivacyPolicy";
import FacebookDataDeletion from "./screens/public/FacebookDataDeletion";
import CommunityAdmin from "./community/CommunityAdmin";
import AdminMotionReviewScreen from "./community/AdminMotionReviewScreen";
import { ADMIN_REVIEW_PATH } from "./community/adminReviewSections";

import { Route, Routes, useLocation } from "react-router-dom";

// import useAuthStore from "./stores/authStore";
import ProtectedRoute from "./navigation/ProtectedRoutes";
import UnprotectedRoute from "./navigation/UnprotectedRoutes";

import './App.css'
// import SideMenu from "./components/allPages/SideMenu";
import SiteHeader from "./components/allPages/SiteHeader";
import { initAnalytics, trackPageView } from "./utils/analytics";


function App() {
  const location = useLocation();
  const hasInitializedRef = useRef(false);
  const lastTrackedPathRef = useRef("");

  useEffect(() => {
    if (!hasInitializedRef.current) {
      initAnalytics();
      hasInitializedRef.current = true;
    }
  }, []);

  useEffect(() => {
    const nextPath = `${location.pathname}${location.search}`;
    if (nextPath === lastTrackedPathRef.current) {
      return;
    }
    lastTrackedPathRef.current = nextPath;
    trackPageView(nextPath);
  }, [location]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.search]);

  return (
    <div className="app app--dark">
      {location.pathname !== ADMIN_REVIEW_PATH && <SiteHeader mode={'dark'} />}

      {/* {user && <SideMenu />} */}

      <Routes>
        {/* AUTHstack */}
        <Route path="/login" element={<UnprotectedRoute><Login /></UnprotectedRoute>} />
        <Route path="/register" element={<UnprotectedRoute><Register /></UnprotectedRoute>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/facebook-data-deletion" element={<FacebookDataDeletion />} />


        {/* APPstack */}
        <Route path="/" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/sightings" element={
          <ProtectedRoute><Sightings /></ProtectedRoute>} />
        <Route path="/settings" element={
          <ProtectedRoute><AdminSettings mode="settings" /></ProtectedRoute>} />
        <Route path="/admin" element={
          <ProtectedRoute><AdminSettings mode="admin" /></ProtectedRoute>} />
        <Route path="/admin/community-reviews" element={
          <ProtectedRoute><CommunityAdmin /></ProtectedRoute>} />
        <Route path={ADMIN_REVIEW_PATH} element={
          <ProtectedRoute><AdminMotionReviewScreen /></ProtectedRoute>} />
       
      </Routes>
    </div>
  );
}

export default App;
